import { useState, useEffect } from "react";

const useOnScreen = (ref: any, rootMargin = "0px") => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        rootMargin
      }
    );

    const currentElement = ref?.current;

    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      observer.unobserve(currentElement);
    };
  }, [ref, rootMargin]);

  return isVisible;
};

export default useOnScreen;

/*export default function useOnScreen(ref: any) {

    const [isIntersecting, setIntersecting] = useState(false)
  
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting)
    )
  
    const fetchObserver = useCallback(() => {
      observer.observe(ref.current)
      return () => { observer.disconnect() }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      fetchObserver()
    }, [fetchObserver]) 
  
    return isIntersecting
  }
  */